import { loan_application, LoanApplication } from '@axo/shared/data-access/types';
import { Broker } from '@axo/shared/data-access/types/broker';

// slots defines available slots for the applications list. This can be
// incremented and adjusted with more types in the future. Note that the order
// of the slot definition will affect the final display order. The current
// application will take precedence, while the rest will be displayed in the
// order configured here.
const slots = [
  {
    Product: loan_application.Product.UnsecuredLoan,
    Broker: Broker.Axo,
  },
  {
    Product: loan_application.Product.UnsecuredLoan,
    Broker: Broker.Zmarta,
  },
  {
    Product: loan_application.Product.SecuredLoan,
  },
  {
    Product: loan_application.Product.CreditCard,
  },
];

export function resolveApplicationsList(
  current: LoanApplication,
  all: LoanApplication[],
): LoanApplication[] {
  const other = all
    .filter((app) => app.ID !== current.ID)
    .filter((app) => app.MarketCountry === current.MarketCountry)
    .sort((a, b) => (a.CreatedAt < b.CreatedAt ? 1 : -1));

  // apps is a sorted list of applications, sorted on priority. Note that the
  // list will be mutated as applications are taken out of if to fill slots.
  let apps = [current, ...other];

  // Attempt to fill each slot with all matching applications.
  let slotted: LoanApplication[] = [];
  slots.forEach((slot) => {
    const matches = apps.filter((app) => {
      if (slot.Product === app.Product) {
        if (slot.Broker === undefined) {
          return true;
        }

        if (slot.Broker === app.Meta?.Broker) {
          return true;
        }
      }

      return false;
    });

    if (matches.length === 0) {
      return;
    }

    // Sort matches so the current application comes first within its group.
    const sorted = matches.sort((a, b) => {
      if (a.ID === current.ID) return -1;
      if (b.ID === current.ID) return 1;
      return 0;
    });

    // Prepend or append based on whether the current application is in
    // this group, to preserve the intended slot order.
    const containsCurrent = sorted[0].ID === current.ID;
    if (containsCurrent) {
      slotted = [...sorted, ...slotted];
    } else {
      slotted = [...slotted, ...sorted];
    }

    apps = apps.filter((app) => !matches.some((m) => m.ID === app.ID));
  });

  return slotted;
}
